export function highlight(text = '', query = '', color?: string) {
    const pattern = new RegExp('(' + query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + ')', 'gi');
    const replaceWith = '<span style="color: ' + (color ? color : 'var(--primary-color)') + ';">$1</span>';

    return text.replace(pattern, replaceWith);
}
